module.exports = __webpack_public_path__ + "img/chr_ts_90_17.881fae19.png";